export const DATA_KEY_STROKE_WIDTH = "mpse__stroke__model__const__stroke_width";
export const DATA_KEY_STROKE_DASHARRAY =
  "mpse__stroke__model__const__stroke_dasharray";
